// 创建路由
import { createRouter, createWebHashHistory } from 'vue-router'
import { deepClone } from "@/utils/commons.js";
//import router from "@/router/index.js";
import store from '@/store'
import router, { baseRoutes } from '@/router/index.js'


// 过滤出符合权限的路由
export function filterAuthRouter(List, userAuth) {
    // List：需要过滤的路由
    // userAuth：权限标识
    List = deepClone(List)
    let newList = []
    for (let i = 0; i < List.length; i++) {
        let isAuth = false
        if (List[i]["meta"] && List[i]["meta"]['auth']) {
            // 当前为需要验证权限的路由
            for (let j = 0; j < List[i].meta['roles'].length; j++) {
                if (userAuth == List[i].meta['roles'][j]) {
                    // 当前路由符合权限
                    isAuth = true
                    break
                }
            }
            if (isAuth) {
                if (List[i].children) {
                    // 存在子项
                    let children = filterAuthRouter(List[i].children, userAuth)
                    let objItem = List[i]
                    objItem.children = children
                    newList.push(objItem)
                } else {
                    // 当前项符合权限
                    newList.push(List[i])
                }
            }
        } else {
            newList.push(List[i])
        }
    }
    return newList
}


// 设置动态路由
export function setAsyncRouters(routers) {
    const asyncRouters = filterAsyncRouter(routers)
    const asyncNames = []

    // 添加主要路由
    asyncRouters.forEach(route => {
        router.addRoute('Layout', route)
        asyncNames.push(route.name)
        /* if (route.children) {
            route.children.forEach(child => asyncNames.push(child.name))
        } */
    })

    // 添加全局404（必须在最后）
    router.addRoute({
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/views/error/404.vue')
    })

    //console.log('当前页面的路由：', router.getRoutes());

    // 存储路由信息
    sessionStorage.setItem('asyncRoutersName', JSON.stringify(asyncNames))
    sessionStorage.setItem('asyncRouters', JSON.stringify(routers))
}


// 重置路由
export function resetRouter() {
    const asyncRoutersNameList = JSON.parse(sessionStorage.getItem('asyncRoutersName'))


    //console.log('重置路由前，当前页面的路由：', router.getRoutes());
    //console.log(asyncRoutersNameList);
    asyncRoutersNameList.forEach(item => {
        router.removeRoute(item)
    });
    sessionStorage.removeItem('asyncRouters')
    sessionStorage.removeItem('asyncRoutersName')
    store.commit('setRoutesLoaded', false)
    //console.log('重置路由后，当前页面的路由：', router.getRoutes());

}

// 处理动态路由组件
export function filterAsyncRouter(routes) {
    const componentMap = {
        Layout: () => import('@/views/Layout.vue'), // 保持与静态路由一致
    }

    const processRoutes = (routes, parentPath = '/') => {
        return routes.map(route => {
            // 处理路径格式
            const isAbsolute = route.path.startsWith('/')
            const fullPath = isAbsolute
                ? route.path
                : `${parentPath}/${route.path}`.replace(/\/+/g, '/')
            // 处理组件
            let component
            if (componentMap[route.component]) {
                //component = componentMap[route.component]
                component = ''
            } else if (route.component) {
                try {
                    component = () => import(`@/views/${route.component}.vue`)
                } catch {
                    component = () => import('@/views/error/404.vue')
                }
            }

            // 构建路由对象
            const processed = {
                ...route,
                path: fullPath,
                component,
                meta: route.meta || {}
            }

            // 递归处理子路由
            /* if (route.children) {
                processed.children = processRoutes(route.children, fullPath)
            } else if (
                // 修改判断条件：所有一级路由都挂载到Layout下（除了Layout本身）
                parentPath === '/' &&
                route.component !== 'Layout'
            ) {
                return {
                    path: '/', // 挂载到Layout的children中
                    component: componentMap.Layout,
                    children: [processed],
                    meta: { hidden: true }
                }
            } */

            if (route.children) {
                processed.children = processRoutes(route.children, fullPath)
            } else if (
                // 修改判断条件：所有一级路由都挂载到Layout下（除了Layout本身）
                parentPath === '/' &&
                route.component !== 'Layout'
            ) {
                return processed
            }

            return processed
        })
    }

    return processRoutes(deepClone(routes)).flat()
}